export type ServiceDisplayInTerminalType = 0 | 1 | 2 | 3;

interface IServicesDisplayInTerminalTypeEnum {
    ShownForIdent: ServiceDisplayInTerminalType;
    ShownForAll: ServiceDisplayInTerminalType;
    ShownForNotIdent: ServiceDisplayInTerminalType;
    NotShown: ServiceDisplayInTerminalType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 0, text: 'Rodoma tik ident. pacientui' },
    { key: 1, text: 'Rodoma visiems' },
    { key: 2, text: 'Rodoma tik neident. pacientui' },
    { key: 3, text: 'Nerodoma' }
];

export const servicesDisplayInTerminalType: IServicesDisplayInTerminalTypeEnum = {
    ShownForIdent: 0,
    ShownForAll: 1,
    ShownForNotIdent: 2,
    NotShown: 3,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
